<template>
  <a-card :bordered="false">
    <Breadcrumb routeName="PaySetting" toName="微信支付" goPathName="支付设置"></Breadcrumb>
    <a-tabs v-model="activeKey" @change="changeTab">
      <a-tab-pane :key="2" tab="微信小程序/H5"></a-tab-pane>
      <a-tab-pane :key="11" tab="抖音小程序" v-if="isShowInfo"></a-tab-pane>
    </a-tabs>
    <a-form-model ref="ruleForm"
                  :label-col="currentFormLayout2.labelCol"
                  :wrapper-col="currentFormLayout2.wrapperCol"
                  :model="ruleForm"
                  :rules="rules"
    >
      <a-form-model-item label="支付状态" :required="true">
        <a-switch checked-children="开" un-checked-children="关" v-model="ruleForm.paymentStatus"/>
      </a-form-model-item>
      <div v-if="isShowInfo">
        <a-form-model-item label="自有支付" :required="true">
          <a-switch checked-children="开" un-checked-children="关" v-model="ruleForm.paymentOwn" :disabled="isAct"/>
        </a-form-model-item>
        <div v-if="activeKey==2">
          <a-form-model-item label="微信支付商户号" prop="paymentMchId">
            <a-input style="width: 320px" placeholder="请输入" allowClear v-model="ruleForm.paymentMchId"/>
          </a-form-model-item>
          <a-form-model-item label="API密钥" prop="paymentMchKey">
            <a-input style="width: 320px" placeholder="请输入" allowClear v-model="ruleForm.paymentMchKey"/>
            <a-tooltip placement="topLeft" style="margin-left: 15px">
              <template slot="title">
                <span>微信商户平台(pay.weixin.qq.com)-->账户中心-->账户设置-->API安全-->密钥设置</span>
              </template>
              <a-icon type="info-circle"/>
            </a-tooltip>
          </a-form-model-item>
          <a-form-model-item label="小程序Appsecret" prop="paymentAppletsMpAppSecret">
            <a-input allowClear placeholder="请输入" style="width: 320px" v-model="ruleForm.paymentAppletsMpAppSecret"/>
          </a-form-model-item>
          <a-form-model-item label="公众号Appsecret" prop="paymentPublicMpAppSecret">
            <a-input allowClear placeholder="请输入" style="width: 320px" v-model="ruleForm.paymentPublicMpAppSecret"/>
          </a-form-model-item>
          <a-form-model-item label="微信支付API证书" prop="paymentMchKeyData">
            <a-upload
              name="multfile"
              v-model="ruleForm.paymentMchKeyData"
              :action="uploadFileUrl"
              :multiple="false"
              :fileList="fileList"
              @change="fileInfo=>handleChange(fileInfo)"
            >
              <a-button>
                <a-icon type="upload"/>
                上传文件
              </a-button>
            </a-upload>
          </a-form-model-item>
        </div>
        <div v-if='activeKey==11'>
          <a-form-model-item label="字节跳动appid" prop="paymentMpAppId">
            <a-input style="width: 320px" :maxLength='50' placeholder="请输入" allowClear
                     v-model="ruleForm.paymentMpAppId"/>
          </a-form-model-item>
          <a-form-model-item label="字节跳动支付secret" prop="paymentMpAppSecret">
            <a-input style="width: 320px" :maxLength='50' placeholder="请输入" allowClear
                     v-model="ruleForm.paymentMpAppSecret"/>
          </a-form-model-item>
          <a-form-model-item label="字节跳动salt" prop="paymentDouSalt">
            <a-input style="width: 320px" :maxLength='50' placeholder="请输入" allowClear
                     v-model="ruleForm.paymentDouSalt"/>
          </a-form-model-item>
          <a-form-model-item label="字节跳动token" prop="paymentDouToken">
            <a-input style="width: 320px" :maxLength='50' placeholder="请输入" allowClear
                     v-model="ruleForm.paymentDouToken"/>
          </a-form-model-item>
        </div>

        <a-form-model-item label="管理人手机号">
          <a-input placeholder="请输入" style="width: 320px" v-model="mobileShow" disabled/>
        </a-form-model-item>
        <a-form-model-item label="图形验证码" prop="verificationImg">
          <a-input :maxLength="4"
                   style="width: 180px"
                   allowClear
                   v-model="ruleForm.verificationImg"
                   placeholder="请输入">
          </a-input>
          <img :src="imageCodeUrl" alt="验证码" class="img-code" @click="restImageCodeUrl">
        </a-form-model-item>
        <a-form-model-item label="安全验证码" prop="verificationCode">
          <a-input allowClear placeholder="请输入" style="width: 180px" :maxLength="6"
                   v-model="ruleForm.verificationCode"/>
          <a-button v-if="second<=0" style="margin-left:10px;width:130px;" @click="getSmsCode()">获取验证码</a-button>
          <a-button v-else style="margin-left: 10px;width:130px;">{{ second }}秒后重新发送</a-button>
        </a-form-model-item>
      </div>
      <a-form-model-item label=" " :colon="false" :required="false">
        <a-button type="primary" @click="saveEvent" :loading="saveLoading">保存</a-button>
        <a-button @click="backEvent" style="margin-left: 10px">返回</a-button>
      </a-form-model-item>
    </a-form-model>
  </a-card>
</template>

<script>
import formMixin from '../../utils/mixins/formMixins'
import Breadcrumb from '@/customComponents/Breadcrumb/Breadcrumb'
import countDownHelper from '../../utils/helper/countDownHelper'
import ruleFormMixins from '@/utils/mixins/ruleFormMixins'

export default {
  name: 'WxPaySetting',
  mixins: [formMixin, ruleFormMixins],
  components: {
    Breadcrumb
  },
  data() {
    return {
      activeKey: 2,
      ruleForm: {
        paymentStatus: false,//支付状态
        paymentOwn: false,//自我支付
        paymentMchId: '',//微信支付商户号
        paymentMchKey: '',//api秘钥
        paymentAppletsMpAppSecret: '',//小程序appSecret
        paymentPublicMpAppSecret: '',
        paymentMchKeyData: '',//微信支付API证书
        verificationImg: '',//图形验证码
        verificationCode: '',//安全验证码

        paymentMpAppId: '',
        paymentMpAppSecret: '',
        paymentDouSalt: '',
        paymentDouToken: ''
      },
      rules: {
        paymentMchId: [
          { required: true, message: '请输入商户号', trigger: 'blur' }
        ],
        paymentMchKey: [
          { required: true, message: '请输入Api秘钥', trigger: 'blur' }
        ],
        paymentAppletsMpAppSecret: [
          { required: true, message: '请输入小程序AppSecret', trigger: 'blur' }
        ],
        paymentMchKeyData: [
          { required: true, message: '请上传微信支付API证书', trigger: 'blur' }
        ],

        paymentMpAppId: [
          { required: true, message: '请输入字节跳动appid', trigger: 'blur' }
        ],
        paymentMpAppSecret: [
          { required: true, message: '请输入字节跳动支付secret', trigger: 'blur' }
        ],
        paymentDouSalt: [
          { required: true, message: '请输入字节跳动salt', trigger: 'blur' }
        ],
        paymentDouToken: [
          { required: true, message: '请输入字节跳动token', trigger: 'blur' }
        ],

        verificationImg: [
          { required: true, message: '请输入图形验证码', trigger: 'blur' }
        ],
        verificationCode: [
          { required: true, message: '请输入安全验证码', trigger: 'blur' }
        ]
      },
      second: 0,
      imageCodeUrl: '',
      randomNum: '',
      uploading: false,
      uploadFileUrl: this.getUploadFileUrl(),
      fileList: [],
      mobileShow: '',
      isAct: false, //true不可操作
      isShowInfo: false,
      timer: null
    }
  },
  mounted() {  //重置  this.$refs.ruleForm.resetFields();
    this.restImageCodeUrl()
    this.getPayStateDetails(2)
    this.getMobile()
    this.getOwn()
  },
  methods: {
    changeTab(key) {
      this.activeKey = key
      this.getPayStateDetails(key)
      this.$refs.ruleForm.clearValidate()//去除校验效果
    },
    getOwn() {
      this.getHttpServices().getUserService().post('api/v2/paySetUp/query/own').then(res => {
        this.isShowInfo = res.ownSwitch
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    getShowMobile(mobile) {
      if (mobile && mobile.length > 3) {
        return mobile.substr(0, 3) + '****' + mobile.substr(mobile.length - 4)
      }
      return mobile
    },
    //获取图片上传地址
    getUploadFileUrl() {
      let appConfig = this.getAppConfig()
      return appConfig.baseUrl + (appConfig.isDev ? '/' : '') + 'base/caertificateAnalysis'
    },
    getPayStateDetails(type) {
      let params = {
        paymentMerchantId: this.$store.getters.userInfo.merchantId,
        paymentType: type
      }
      this.getHttpServices().getUserService().post('/api/v2/paySetUp/query/details', params).then(res => {
        if (res) {
          let resultParams = {}
          if (this.activeKey == 2) {
            resultParams = {
              paymentId: res.paymentId,
              paymentMerchantId: res.paymentMerchantId,
              paymentMchId: res.paymentConfigurationVo ? res.paymentConfigurationVo.paymentMchId : '',//微信支付商户号
              paymentMchKey: res.paymentConfigurationVo ? res.paymentConfigurationVo.paymentMchKey : '',//api秘钥
              paymentAppletsMpAppSecret: res.paymentConfigurationVo ? res.paymentConfigurationVo.paymentAppletsMpAppSecret : '',
              paymentPublicMpAppSecret: res.paymentConfigurationVo ? res.paymentConfigurationVo.paymentPublicMpAppSecret : '',
              paymentMchKeyData: res.paymentConfigurationVo ? res.paymentConfigurationVo.paymentMchKeyData : ''//微信支付API证书
            }
          } else {
            resultParams = {
              paymentId: res.paymentId,
              paymentMerchantId: res.paymentMerchantId,
              paymentMpAppId: res.douConfigurationVo ? res.douConfigurationVo.paymentMpAppId : '',//字节跳动appid 必填
              paymentMpAppSecret: res.douConfigurationVo ? res.douConfigurationVo.paymentMpAppSecret : '',//字节跳动 Secret 必填
              paymentDouSalt: res.douConfigurationVo ? res.douConfigurationVo.paymentDouSalt : '',//抖音支付秘钥 SALT(盐值)
              paymentDouToken: res.douConfigurationVo ? res.douConfigurationVo.paymentDouToken : ''//抖音支付回调解密秘钥
            }
          }
          this.ruleForm = {
            paymentStatus: res.paymentStatus == 1 ? true : false,//支付状态
            paymentOwn: res.paymentOwn == 1 ? true : false,//自我支付
            ...resultParams
          }
          this.isAct = res.paymentOwn == 1 ? true : false
        } else {
          this.restFormData()
        }
        this.getLogUtils().logWithTag('this.ruleForm', this.ruleForm)
      }).catch(reason => {
        this.restFormData()
        this.showNetWorkErrorMessage(reason)
      })
    },
    getMobile() {
      this.getHttpServices().getUserService().post('/api/v2/paySetUp/query/mobile', {}).then(res => {
        if (res) {
          this.merchantMobile = res
          this.mobileShow = this.getShowMobile(res)
        }
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    handleChange(file) { //  图片上传成功
      if (file.file.status != 'removed') {
        this.fileList = [...file.fileList]
        this.fileList = this.fileList.slice(-1)
        this.fileList.forEach(file => {
          if (file.response) {
            let imageUrl = file.response.data
            this.ruleForm.paymentMchKeyData = imageUrl
          }
        })
      }
    },
    restFormData() {
      this.isAct = false
      this.ruleForm = {
        paymentId: '',
        paymentMerchantId: '',
        paymentStatus: false,//支付状态
        paymentOwn: false,//自我支付
        paymentMchId: '',//微信支付商户号
        paymentMchKey: '',//api秘钥
        paymentAppletsMpAppSecret: '',//小程序appSecret
        paymentPublicMpAppSecret: '',
        paymentMchKeyData: '',//微信支付API证书
        verificationImg: '',//图形验证码
        verificationCode: '',//安全验证码

        paymentMpAppId: '',
        paymentMpAppSecret: '',
        paymentDouSalt: '',
        paymentDouToken: ''
      }
    },
    restImageCodeUrl() {
      this.randomNum = (Math.random() * new Date().getTime()).toFixed(0)
      this.imageCodeUrl = this.getAppConfig().baseUrl + 'code/getCode/' + this.randomNum
    },
    getSmsCode() {
      const verificationImg = this.ruleForm.verificationImg
      if (verificationImg && (typeof verificationImg === 'string' || typeof verificationImg === 'number')) {
        const params = {
          effect: 7,
          mobile: this.merchantMobile,
          randomNum: this.randomNum,
          userType: 1,
          verificationImg: verificationImg,
          isValidationImg: false
        }
        this.getHttpServices().getBaseService().post('sms/verification', params)
          .then(res => {
            this.$message.success('短信验证码已经发送')
            this.startTimer()
          }).catch(reason => this.showNetWorkErrorMessage(reason))
      } else {
        this.$message.success('请输入图形验证码')
      }

    },
    startTimer() {
      if (!this.timer) {
        this.timer = new countDownHelper(60000, 1000)
        this.timer.onCountDownListener = (timeInfo) => {
          this.second = timeInfo.second
        }
        this.timer.onFinishListener = () => {
          this.second = 0
          this.timer = undefined
        }
        this.timer.start()
      }
    },
    saveEvent() {
      if (!this.isShowInfo) {  //暂时屏蔽修改支付状态直接提交
        this.closeData()
        return
      }
      if (this.activeKey == 2) {
        if (this.ruleForm.paymentOwn) {
          if (!this.ruleForm.paymentPublicMpAppSecret) {
            this.$message.warn('请输入公众号appSecret')
            return
          }
        }
      }
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          if (this.activeKey == 2) {
            this.submitData()
          } else {
            this.submitTiktokData()
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    closeData() {
      const params = {
        paymentId: this.ruleForm.paymentId,
        paymentMerchantId: this.$store.getters.userInfo.merchantId,
        paymentStatus: this.ruleForm.paymentStatus ? 1 : 2
      }
      this.saveLoading = true
      this.getHttpServices().getUserService().post('api/v2/paySetUp/paymentStatus/update', params)
        .then(res => {
          this.$message.success('设置成功')
          setTimeout(() => this.backEvent(), 500)
        }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.saveLoading = false)
    },
    submitData() {
      const params = {
        mobile: this.merchantMobile,
        paymentId: this.ruleForm.paymentId,
        paymentMchId: this.ruleForm.paymentMchId,
        paymentMchKey: this.ruleForm.paymentMchKey,
        paymentMchKeyData: this.ruleForm.paymentMchKeyData,
        paymentMerchantId: this.$store.getters.userInfo.merchantId,
        paymentMpAppSecret: this.ruleForm.paymentMpAppSecret,
        paymentOwn: this.ruleForm.paymentOwn ? 1 : 2,
        paymentStatus: this.ruleForm.paymentStatus ? 1 : 2,
        verificationCode: this.ruleForm.verificationCode,
        paymentAppletsMpAppSecret: this.ruleForm.paymentAppletsMpAppSecret,
        paymentPublicMpAppSecret: this.ruleForm.paymentPublicMpAppSecret
      }
      this.saveLoading = true
      this.getHttpServices().getUserService().post('api/v2/paySetUp/wx/save', params).then(res => {
        this.$message.success('设置成功')
        setTimeout(() => this.backEvent(), 500)
      }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.saveLoading = false)
    },
    submitTiktokData() {
      const params = {
        paymentId: this.ruleForm.paymentId,
        paymentMerchantId: this.$store.getters.userInfo.merchantId,
        paymentMpAppId: this.ruleForm.paymentMpAppId,//字节跳动appid 必填
        paymentMpAppSecret: this.ruleForm.paymentMpAppSecret,//字节跳动 Secret 必填
        paymentDouSalt: this.ruleForm.paymentDouSalt,//抖音支付秘钥 SALT(盐值)
        paymentDouToken: this.ruleForm.paymentDouToken,//抖音支付回调解密秘钥
        mobile: this.merchantMobile,
        paymentOwn: this.ruleForm.paymentOwn ? 1 : 2,
        paymentStatus: this.ruleForm.paymentStatus ? 1 : 2,
        verificationCode: this.ruleForm.verificationCode
      }
      this.saveLoading = true
      this.getHttpServices().getUserService().post('api/v2/paySetUp/dou/save', params).then(res => {
        this.$message.success('设置成功')
        setTimeout(() => this.backEvent(), 500)
      }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.saveLoading = false)
    }
  }
}
</script>
<style lang="less" scoped>
.image {
  width: 100px;
  height: 100px;
}

.img-code {
  width: 130px;
  height: 30px;
  margin-left: 15px;
  margin-top: -4px;
}
</style>